<template>
	<div>
		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<b-row class="modificationLabel">{{ this.modification }}</b-row>
		<div class="row">
			<div class="col-12 col-lg-4 mt-5"
				v-for="(step, index) in keyPairsList"
				:key="step.order">
				<div class="form-group">
					<label class="title_label"
						:for="'num' + index">{{ $t('Keynum.number') }} {{ step.order }}</label> <input type="text"
					class="form-control no-border"
					:id="'num' + index"
					@input="setModified"
					v-model="step.number"> <br> <label class="title_label"
					:for="'lbl' + index">{{ $t('Keynum.explanation') }} {{ step.order }}</label> <input type="text"
					class="form-control no-border"
					:id="'lbl' + index"
					@input="setModified"
					v-model="step.text">
				</div>
			</div>
		</div>
		<div class="row">
			<div class="form-group">
				<label><input type="checkbox" name="mute" v-model="hasMusicEnable"
					@input="setModified" /> {{ $t("Button.enable_music") }}</label>
				<span class="modificationLabel"></span><br />
				<label>Volume : {{ music_volume }}%<br /><input :disabled="!hasMusicEnable" @change="setModified" type="range" id="music_volume" name="music_volume"
					min="10" max="100" step="10" v-model="music_volume"></label>
			</div>
		</div>
		<b-row class="row">
			<b-col md="auto">
				<ValidStep :id="this.id"
					:keyPairs="this.keyPairsList"
					:modal="this.$refs.loaderModal"
					:music_enabled="hasMusicEnable"
					:music_volume="music_volume"
				/>
			</b-col>
			<b-col md="auto" style="padding-left: 0;">
				<div class="mt-4">
					<a href="#"
						class="btn btn-cancel"
						@click="reset_modified"
						:class="[modified ? '' : 'disabled']">{{ $t("Button.modifications") }}</a>
				</div>
			</b-col>
		</b-row>

	</div>
</template>

<script>
import ValidStep from "../ui/buttons/ValidStepKeynumber";
import axios from "axios";
import lottie_error from "@/components/ui/lottie_error";
import {EventBus} from "../../event/event-bus.js";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Keynumber",
	components: {
		lottie_error,
		ValidStep,
	},
	props: {
		id: Number,
		stepName: String,
		projectId: Number,
		stepOrder: Number,
		visibility: Number,
		renderId: String,
		created_at: String,
		updated_at: String,
	},
	data() {
		return {
			keyPairsList: [],
			keyText: "",
			keyNumber: "",
			text_error: "",
			modified: false,
			modification: "",
			hasMusicEnable: false,
			music_volume: 100,
			keynum_max: 2,
		};
	},
	created() {
		EventBus.$on("setModified", bool => {
			if (bool) {
			}
			else {
				this.reset_modified();
			}
		});
	},
	beforeMount() {
		this.getData();
	},
	methods: {
		getData() {
			let $this = this;

			axios.get(BASE_URL + "/public/api/stepKeynumbers/" + this.id,
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
			.then(function (response) {
				let data = response.data.data;

				$this.hasMusicEnable = data.hasMusicEnable;
				$this.music_volume = data.music_volume;

				$this.isCompleted = data.isCompleted;

				if (data.isCompleted) {
					EventBus.$emit("setStepTitleComplete", $this.id);
				}
				else {
					EventBus.$emit("setStepTitleNotComplete", $this.id);
				}
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
			axios
			.get(BASE_URL + "/public/api/stepKeynumbers/" + $this.id + "/keyPairs",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			)
			.then(function (response) {
				let data = response.data;

				$this.keyPairsList = [];

				data.forEach(function (item) {
					$this.keyPairsList.push(item);
				});

				while ($this.keyPairsList.length < $this.keynum_max) {
					$this.keyPairsList.push({"number": "", "text": "", "order": $this.keyPairsList.length + 1});
				}
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		resetValueText(e, index) {
			e.target.value = "";
			this.keyPairsList[index].keyText = "";
		},
		resetValueNumber(e, index) {
			e.target.value = "";
			this.keyPairsList[index].keyNumber = "";
		},
		setModified() {
			this.modified = true;
			this.modification = this.$root.$t("Button.editing");
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepKeynumber"});
		},
		reset_modified() {
			this.getData();
			EventBus.$emit("unlock_steps", {id: this.id, type: "App\\StepKeynumber"});
			this.modified = false;
			this.modification = "";
		},
	},
};
</script>

<style scoped>
.btn {
	border-radius: var(--small-border-radius);
}

.title_label {
	font-size: 14px;
	color: #000000;
}

input {
	border-top: none;
	border-left: none;
	border-right: none;
	border-bottom: #000000 solid 1px;
}

.modificationLabel {
	color: var(--color-modification);
	height: 30px;
}

.btn-cancel {
	background-color: var(--color-modification);
	border-color: var(--color-modification);
	color: var(--text-modification);
}

</style>
